module.exports = __webpack_public_path__ + "img/1536801408.b7a400d5.jpg";